<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-analysis/modelList' }">模型管理</el-breadcrumb-item>
            <el-breadcrumb-item><a @click.prevent="goBack">模型配置</a></el-breadcrumb-item>
            <el-breadcrumb-item>主体配置页</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <el-form ref="myForm" :model="formData" :rules="formRules" :label-width="formLabelWidth">
          <el-form-item :label="'主体（' + areaTypeName + '）:'" prop="area_id">
            <el-select
              v-model="formData.area_id"
              filterable
              clearable
              @change="areaSelectChange"
            >
              <el-option
                v-for="item in areaData"
                :key="item.id"
                :label="item.full_area_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div class="zv-flex-wrap">
            <div class="zv-form-item-label">风险模块权重配置:</div>
            <div class="zv-form-item-content" style="display: block; max-width: 1205px;">
              <el-table
                :data="modelMainItems"
                style="width: 100%"
                class="my-expand-table"
              >
                <el-table-column type="expand" :width="120" :align="tableAlign">
                  <template slot="header" slot-scope="scope">
                    <span>模块内容配置</span>
                  </template>
                  <template slot-scope="scope">
                    <div class="config-model-table-title style-mt-0">参考因素配置(B)</div>
                    <el-table :data="subTables[scope.$index].table1" class="style-auto-height">
                      <el-table-column label="名称" :align="tableAlign" prop="field_name"></el-table-column>
                      <el-table-column label="得分编号" :align="tableAlign" prop="first_no">
                      </el-table-column>
                      <el-table-column label="权重编号" :align="tableAlign" prop="second_no">
                      </el-table-column>
                      <el-table-column label="条件类型" :align="tableAlign" prop="prop">
                        <template slot-scope="scope">
                          <span>{{ scope.row.field_type == 1 ? '单条件' : '多条件' }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="参考因素权重值" :align="tableAlign">
                        <template slot-scope="scope">
                          <el-input type="number" v-model="scope.row.value" placeholder="0~100整数">
                            <template slot="append">%</template>
                          </el-input>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div class="config-model-main-tips">*权重值之和应等于100</div>
                    <div class="config-model-table-title">加权项配置(W)</div>
                    <el-table :data="subTables[scope.$index].table2" class="style-auto-height" :align="tableAlign">
                      <el-table-column label="类型" :align="tableAlign" prop="text"></el-table-column>
                      <el-table-column label="得分编号" :align="tableAlign" prop="first_no">
                      </el-table-column>
                      <el-table-column label="权重编号" :align="tableAlign" prop="second_no">
                      </el-table-column>
                      <el-table-column label="因素配置" :align="tableAlign">
                        <template slot-scope="scope" v-if="!scope.row.hasValue">
                          <el-button type="text" @click="openFactorConfigDialog(scope.row)">新增</el-button>
                        </template>
                      </el-table-column>
                      <el-table-column label="配置值" :align="tableAlign">
                        <template slot-scope="scope" v-if="scope.row.hasValue">
                          <el-input type="number" v-model="scope.row.value" placeholder="两位小数"></el-input>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div class="config-model-table-title">特殊加权项配置(S)</div>
                    <el-table :data="subTables[scope.$index].table3" class="style-auto-height">
                      <el-table-column label="类型" :align="tableAlign" prop="text"></el-table-column>
                      <el-table-column label="得分编号" :align="tableAlign" prop="first_no">
                      </el-table-column>
                      <el-table-column label="权重编号" :align="tableAlign" prop="second_no">
                      </el-table-column>
                      <el-table-column label="因素配置" :align="tableAlign">
                        <template slot-scope="scope" v-if="!scope.row.hasValue">
                          <el-button type="text" @click="openFactorConfigDialog(scope.row)">新增</el-button>
                        </template>
                      </el-table-column>
                      <el-table-column label="配置值" :align="tableAlign">
                        <template slot-scope="scope" v-if="scope.row.hasValue">
                          <el-input type="number" v-model="scope.row.value" placeholder="两位小数"></el-input>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div class="config-model-table-title">减分项配置(S)</div>
                    <el-table :data="subTables[scope.$index].table4.data" class="style-auto-height">
                      <el-table-column v-for="(column, idx) in subTables[scope.$index].table4.items" :key="idx" :label="column.label"  :align="tableAlign">
                        <template slot-scope="scope">
                          <el-input type="number" v-model="scope.row[column.key]" :value="scope.row[column.key]" placeholder="两位小数"></el-input>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column label="风险模块名称" :align="tableAlign" prop="pattern_item_name" >
                </el-table-column>
                <el-table-column label="模块风险类型" :align="tableAlign" prop="risk_name">
                </el-table-column>
                <el-table-column label="模块编号" :align="tableAlign" prop="first_no">
                </el-table-column>
                <el-table-column label="模块权重编号" :align="tableAlign" prop="second_no">
                </el-table-column>
                <el-table-column label="风险模块权重值" :align="tableAlign">
                  <template slot-scope="scope">
                    <el-input type="number" v-model="riskModelWeightArr[scope.$index].value" placeholder="0~1两位小数"></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <el-form-item label-width="auto" class="fi-flex-center paddint-t-30">
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="doSubmit">提交</el-button>
          </el-form-item>
        </el-form>
        <zv-dialog
          width="600px"
          title="因素配置"
          :showDialog.sync="showFormDialog"
          @close-dialog="closeFormDialog"
        >
          <div slot="content">
            <div style="text-align: right; padding-bottom: 10px;">
              <el-button type="primary" @click="doAddConfigRow()">添加选项</el-button>
            </div>
            <el-table :data="dialogCurTable.data" class="style-auto-height" style="margin-bottom: 10px;">
              <el-table-column label="节日名称" :align="tableAlign" v-if="dialogCurTable.curId == 2">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.pattern_item_field_value"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in areaFestivalList"
                      :key="item.id"
                      :label="item.festival"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column label="影响性类型" :align="tableAlign" v-if="dialogCurTable.curId == 3">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.pattern_item_field_value"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in areaTypeForEventList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column label="特殊加权字段" :align="tableAlign" v-if="dialogCurTable.curId == 5">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.extraValue"
                    filterable
                    clearable
                    @change="specialExtraSelectChange(scope)"
                  >
                    <el-option
                      v-for="item in getBaseRiskFieldByIndex(dialogCurTable.modelIndex)"
                      :key="item.id"
                      :label="item.field_name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column label="选项" :align="tableAlign" v-if="dialogCurTable.curId == 5">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.pattern_item_field_value"
                    filterable
                    clearable
                    v-if="scope.row.parentIndex !== ''"
                  >
                    <el-option
                      v-for="item in modelMainItems[dialogCurTable.modelIndex].base_risk_field[scope.row.parentIndex].area_risk_field_option || []"
                      :key="item.id"
                      :label="item.risk_field_value"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column :align="tableAlign" :label="dialogCurTable.curId | configTitleText">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.pattern_item_field_score" placeholder="0~1两位小数"></el-input>
                </template>
              </el-table-column>

              <el-table-column :align="tableAlign" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="doDeleteConfigRow(scope)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div slot="btns">
            <el-button @click="showFormDialog = false">取消</el-button>
            <el-button type="primary" @click="doSaveFactorOptions">确定</el-button>
          </div>
        </zv-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from './api';
import formPageMixin from "@/mixins/formPageMixin";
import addFormMixin from "@/mixins/addFormMixin";
import TipUtil from "@/utils/utils/TipUtil";
import _ from "lodash";

export default {
  name: "CreateModelMain",
  mixins: [formPageMixin, addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      pattern_id: '', // 模型id
      area_id: '', // 地区id
      area_type: '', // 模型类型
      isEdit: false,   // 是否为编辑
      areaData: [],  // 地区数据
      modelMainInfo: {} , // 模型主体详情
      modelMainItems: [] , // 模型主体
      formData: {
        area_id: '',  // 主体（国家）id
      },
      formRules: {
        area_id: {
          required: true,
          message: "主体不能为空",
          trigger: "change"
        }
      },
      riskModelWeightArr: [],  // 风险模块权重值数组
      riskModelFieldWeightArr: [], // 模块参考因素项目的权重
      tableOri: {

      },
      subTables: [],     // 子表格数据
      // subTables: [{   // 子表格数据
      //   table1: [],
      //   table2: [],
      //   table3: [],
      //   table4: []
      // }],

      // 弹出的三个table数据
      dialogTablesData: [],
      // 弹出框表格数据数组
      dialogCurTable: {
        curId: '',
        modelIndex: 0,
        data: []
      },

      // 国家节日下拉选项数据
      areaFestivalList: [],
      // 影响性下拉数据
      areaTypeForEventList: vm.$enums.AreaType.forEventList,
      // 特殊加权下拉选项数据
      areaRiskTypeList: [],
    };
  },
  computed: {
    areaTypeName() {
      return this.$enums.AreaType.getForModeName(this.area_type)
    }
  },

  methods: {
    initCommonData() {
      this.formData.area_id = this.area_id
      this.$commFunc.getAreaList({area_type: this.area_type}).then(res => {
        this.areaData = res
      })
      this.getAreaCommonData()
    },

    areaSelectChange(area_id) {
      this.area_id = area_id;
      this.getAreaCommonData();
    },

    getAreaCommonData() {
      this.getModelMainInfo()
      this.getFestivalList()
    },

    // 获取模块详情
    async getModelMainInfo() {
      if (this.area_id && this.pattern_id) {
        // 获取模型主体详情信息
        let res = await api.modelMainDetail({
          pattern_id: this.pattern_id,
          area_id: this.area_id
        })

        console.log('rrrrrrrrrrrrres')
        console.log(res)
        this.modelMainInfo = res.info
        let riskModelWeightArrTemp = []
        let subTableArr = []
        let dialogTableArr = []
        res.info.pattern_item.forEach((item, modelIndex) => {
          item.first_no = `M${item.id}`
          item.second_no = `Pm${item.id}`
          let isNew = item.area_weight_config ? true : false
          riskModelWeightArrTemp.push({
            id: item.id,
            value: isNew ? item.area_weight_config.pattern_item_weight : ''
          })

          subTableArr.push(this.getSubTablesData(item, modelIndex))
          dialogTableArr.push(this.getDialogTablesData(item, modelIndex))
        })

        this.subTables = subTableArr  // 赋值子表格数据
        this.dialogTablesData = dialogTableArr  // 赋值子表格数据
        this.riskModelWeightArr = riskModelWeightArrTemp   // 赋值风险模块权重值数组
        this.modelMainItems = res.info.pattern_item
      }
    },

    // 获取节日列表
    async getFestivalList() {
      let res = await api.festivalList({
        page: 1,
        pagesize: 99999,
        area_id: this.area_id
      })

      console.log(res)

      this.areaFestivalList = res.list
    },

    getSubTablesData(modelItem, modelIndex) {
      let areaConfig = modelItem.area_weight_config
      let isNew = areaConfig ? false : true
      let tempObj = {
        table1: this.setSubTable1Data(modelItem, modelIndex, areaConfig, isNew),
        table2: this.setSubTable2Data(modelItem, modelIndex, areaConfig, isNew),
        table3: this.setSubTable3Data(modelItem, modelIndex, areaConfig, isNew),
        table4: this.setSubTable4Data(modelItem, modelIndex, areaConfig, isNew)
      }
      return tempObj
    },

    setSubTable1Data(modelItem, modelIndex, areaConfig, isNew) {
      let retArr = []
      let weightArr = []
      let areaRiskTypeArr = []
      if (isNew) {
        weightArr = new Array(modelItem.base_risk_field.length).fill('')
      } else {
        weightArr = areaConfig.base_risk_field_weight
      }

      modelItem.base_risk_field.map((item, index) => {
        let tempObj = Object.assign({}, item, {
          modelIndex,
          first_no: `B${item.id}`,
          second_no: `Pb${item.id}`,
          value: weightArr[index] ? weightArr[index] * 100 : weightArr[index]
        })
        retArr.push(tempObj)
        areaRiskTypeArr.push(this.$_.cloneDeep(item))
      })

      this.areaRiskTypeList = areaRiskTypeArr
      return retArr
    },

    setSubTable2Data(modelItem, modelIndex, areaConfig, isNew) {
      let retArr = [{
        id: 1,
        text: '关联性',
        formKey: 'related_weight',
        parentId: modelItem.id,
        hasValue: true,
      }, {
        id: 2,
        text: '触发重大时间节点',
        parentId: modelItem.id
      }, {
        id: 3,
        text: '影响性',
        parentId: modelItem.id
      }, {
        id: 4,
        text: '是否流血事件',
        formKey: 'bleeding_weight',
        parentId: modelItem.id,
        hasValue: true
      }]

      retArr.forEach(item => {
        item.modelIndex = modelIndex
        item.first_no = `W${item.id}`
        item.second_no = `Pw${item.id}`
        if (!isNew && item.hasValue) {
          item.value = areaConfig[item.formKey]
        }
      })

      return retArr
    },

    setSubTable3Data(modelItem, modelIndex, areaConfig, isNew) {
      let retArr = [{
        id: 5,
        text: '特殊加权',
        formKey: 'related_weight'
      }]

      retArr.forEach(item => {
        item.modelIndex = modelIndex
        item.first_no = `S${item.id}`
        item.second_no = `Ps${item.id}`
        if (!isNew && item.hasValue) {
          item.value = areaConfig[item.formKey]
        }
      })

      return retArr
    },

    setSubTable4Data(modelItem, modelIndex, areaConfig, isNew) {
      let retArr = ['低', '一般', '中等', '较高', '极高']
      let itemsArr = []
      let tempObj = {}
      retArr.forEach((item, index) => {
        let key = `minus_${index}_weight`
        tempObj[key] = isNew ? '' : areaConfig[key]

        let tempItemObj = {
          label: item,
          key
        }
        itemsArr.push(tempItemObj)
      })
      retArr.push(tempObj)
      return {
        data: [tempObj],
        items: itemsArr
      }
    },

    // 获取弹出窗3个表格数据
    getDialogTablesData(modelItem, modelIndex) {
      let areaConfig = modelItem.area_weight_config
      let isNew = areaConfig ? false : true
      let tempObj = {}
      let idArrs = [-2, -3, -5];  // -2 重大事件节点; -3影响性; -5特殊加权
      idArrs.forEach(item => {
        let tempArr = []
        if (!isNew) {
          tempArr = this.setDialogTableData(item, modelItem, modelIndex, areaConfig)
        }
        tempObj['table' + Math.abs(item)] = tempArr

      })
      return tempObj
    },

    setDialogTableData(optionId, modelItem, modelIndex, areaConfig) {
      console.log('111111111111')
      let retArr = []
      let optionsArr = areaConfig.area_pattern_item_field_option
      if (optionsArr && optionsArr.length) {
        optionsArr.forEach(item => {
          let tempValue = parseInt(item.pattern_item_field_value)
          item.pattern_item_field_value = isNaN(tempValue) ? '' : tempValue
          if (item.pattern_item_option_id == optionId) {
            let tempObj = Object.assign({}, item, {
              modelIndex
            })

            if (item.pattern_item_option_id == -5) {
              let extraValue = ''
              let parentIndex = ''
              let itemId = item.pattern_item_field_value
              let parantFindIndex = modelItem.base_risk_field.findIndex(subItem => {
                let retVal = false
                if (subItem.area_risk_field_option.length) {
                  subItem.area_risk_field_option.forEach(subSubItem => {
                    if (subSubItem.id == itemId) {
                      retVal = true
                    }
                  })
                }

                return retVal
              })

              if (parantFindIndex > -1) {
                extraValue = modelItem.base_risk_field[parantFindIndex].id
                parentIndex = parantFindIndex
              }

              tempObj.extraValue = extraValue
              tempObj.parentIndex = parentIndex
            }

            retArr.push(tempObj)
          }
        })
      }

      return retArr
    },

    // 加权项因素配置
    openFactorConfigDialog(scopeRow) {
      this.setDialogTableItemData(scopeRow);
      this.$nextTick(() => {
        this.openFormDialog();
      })
    },

    // 设置打开dialog的表格数据
    setDialogTableItemData(scopeRow) {
      let dialogIndex = scopeRow.id
      let tempTableData = this.$_.cloneDeep(this.dialogTablesData[scopeRow.modelIndex]['table' + dialogIndex])
      this.dialogCurTable = {
        curId: dialogIndex,
        modelIndex: scopeRow.modelIndex,
        data: tempTableData
      }
    },

    // 特殊加权项字段下拉change事件
    specialExtraSelectChange(scope) {
      console.log(scope)
      let itemIndex = scope.$index
      let extraValue = scope.row.extraValue

      let findIndex =  this.modelMainItems[this.dialogCurTable.modelIndex].base_risk_field.findIndex(item => {
        return item.id == extraValue
      })

      if (findIndex == -1) {
        findIndex = ''
      }

      this.$set(this.dialogCurTable.data, itemIndex, Object.assign({ },
        this.dialogCurTable.data[itemIndex] , {
        parentIndex: findIndex,
        pattern_item_field_value: ''
      }))
    },

    // 添加配置项
    doAddConfigRow() {
      let rowItemObj = {
        id: '',
        modelIndex: this.dialogCurTable.modelIndex,
        pattern_item_field_score: '',
        pattern_item_field_value: '',
        pattern_item_option_id: -this.dialogCurTable.curId,
        extraValue: '',
        parentIndex: ''
      }

      this.dialogCurTable.data.push(rowItemObj)
    },

    // 添加配置项
    async doDeleteConfigRow(scope) {
      let scopeRow = scope.row
      await this.$confirm(
        '确定删除该条记录？',
        '提示',
        {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })

      if (scopeRow.id) {
        await api.deleteModelMainField({
          id: scopeRow.id
        })
      }

      this.dialogCurTable.data.splice(scope.$index, 1)
      this.dialogTablesData[this.dialogCurTable.modelIndex]['table' + this.dialogCurTable.curId].splice(scope.$index, 1)
    },

    // 保存因素配置
    async doSaveFactorOptions() {
      let curTableData = this.dialogCurTable.data
      // 判断是否都已填写
      let isAllFilled = curTableData.some(item => item.pattern_item_field_value === '' || item.pattern_item_field_score === '')
      if (isAllFilled) {
        TipUtil.message('表单还有未填项', 'error')
        return false
      }
      let tableOri = this.dialogTablesData[this.dialogCurTable.modelIndex]['table' + this.dialogCurTable.curId]
      for (let index = 0; index < curTableData.length; index++) {
        let item = curTableData[index]
        // 如果id不为空则为编辑
        if (item.id) {
          // 如果有改变才调编辑接口
          if (
            item.pattern_item_field_value !== tableOri[index].pattern_item_field_value ||
            item.pattern_item_field_score !== tableOri[index].pattern_item_field_score
          ) {
            await api.editModelMainField(
              this.$_.pick(item, ['id',
              'pattern_item_field_value', 'pattern_item_field_score'])
            )
          }
        } else {
          let res = await api.addModelMainField(
            this.$_.pick(item, ['pattern_item_option_id',
            'pattern_item_field_value', 'pattern_item_field_score'])
          )
          console.log('rrrrrrrrrr')
          console.log(res)
          item.id = res.option_id
        }

        if (index == curTableData.length - 1) {
          this.$set(this.dialogTablesData[this.dialogCurTable.modelIndex], 'table' + this.dialogCurTable.curId, this.$_.cloneDeep(curTableData))
          this.closeFormDialog()
        }
      }
    },

    doSubmit() {
      this.$refs.myForm.validate(async valid => {
        if (!valid) {
          TipUtil.message('请检查表单!', 'warning')
          return
        }
        let processObj = this.processSubmitData()
        console.log(processObj)
        let res = await api.addModelMain(processObj)
        console.log(res)
        let msg = this.isEdit ? '修改主体配置成功' : '新增主体模型成功'
        TipUtil.message(msg, "success")
        setTimeout(() => {
          this.goBack()
        }, 200)
      })
    },

    processSubmitData() {
      let processObj = {
        area_id: this.area_id,
        pattern_id: this.pattern_id,
        pattern_item_id: this.modelMainItems.map(item => item.id).join(','),
        pattern_item_weight: this.getSubmitModelWeight(),
        pattern_item_risk_field_weight: this.getSubmitModelFactorFieldWeight(),
        area_pattern_item_field_option_id: this.getSubmitThreeAddonFieldOptions(),
        area_related_weight: this.getSubmitRelatedWeight(),
        area_bleeding_weight: this.getSubmitBleedingWeight(),
        ...this.getSubmitMinusValues()
      }

      return processObj
    },

    // 获取主模块风险权重值
    getSubmitModelWeight() {
      let retArr = this.riskModelWeightArr.map(item => item.value)
      return retArr.join(',')
    },

    // 获取参考因素权重值
    getSubmitModelFactorFieldWeight() {
      let retArr = []
      this.subTables.forEach(item => {
        let mapArr = item.table1.map(subItem => _.floor(subItem.value / 100, 2))
        retArr.push(mapArr.join('#'))
      })
      return retArr.join(',')
    },

    // 获取三种加权项配置选项数组
    getSubmitThreeAddonFieldOptions() {
      let retArr = []
      this.dialogTablesData.forEach(item1 => {
        let itemsArr = [2, 3, 5]
        let tempItemArr = []
        itemsArr.forEach(item2 => {
          let mapArr = item1['table' + item2].map(item3 => item3.id)
          tempItemArr.push(mapArr.join('/'))
        })
        retArr.push(tempItemArr.join('#'))
      })
      return retArr.join(',')
    },

    // 获取三种因素配置选项数组
    getSubmitRelatedWeight() {
      let retArr = this.subTables.map(item => {
        console.log(item)
        console.log(item.table2)
        return item.table2[0] ? item.table2[0].value : ''
      })
      return retArr.join(',')
    },

    // 获取特殊加权项是否流血事件配置值
    getSubmitBleedingWeight() {
      let retArr = this.subTables.map(item => {
        console.log(item)
        console.log(item.table2)
        return item.table2[3] ? item.table2[3].value : ''
      })
      return retArr.join(',')
    },

    // 获取减分项配置值
    getSubmitMinusValues() {
      let retObj= {}
      for(let i = 0; i < 5; i++) {
        let tempArr = []
        let itemKey = `minus_${i}_weight`
        let subItemKey = 'area_' + itemKey
        this.subTables.forEach(item => {
          tempArr.push(item.table4.data[0][itemKey])
        })

        retObj[subItemKey] = tempArr.join(',')
      }
      return retObj
    },

    getBaseRiskFieldByIndex(modelIndex) {
      let resArr = this.modelMainItems[modelIndex].base_risk_field.filter(item => {
        if (item.field_name != '华人涉事人数' && item.field_name != '涉事人数') {
          return true
        }

        return false
      })

      return resArr
    }
  },

  created() {
    let pattern_id = this.$route.query.pattern_id
    if (pattern_id) {
      this.pattern_id = parseInt(pattern_id)
    }
    let area_type = this.$route.query.area_type
    if (area_type) {
      this.area_type = area_type
    }

    let area_id = this.$route.query.area_id
    if (area_id) {
      this.area_id = parseInt(area_id)
      this.isEdit = true
    }

    this.initCommonData();
  },
  mounted() {
  },
  beforeDestroy() {

  },
  filters: {
    configTitleText(curId) {
      let retStr = ''
      if (curId == 2) {
        retStr = '节日'
      } else if (curId == 3) {
        retStr = '影响性'
      } else if (curId == 5) {
        retStr = '特殊加权'
      }

      return `${retStr}配置值`
    }
  }
};
</script>

<style lang="less">
  .config-model-table-title {
    margin-top: 15px;
    padding: 15px 20px;
    background: #f6f6f6;
    text-align: center;
    border-bottom: 1px solid #ddd;
    border-top: 1px solid #ddd;
    font-size: 14px;
    font-weight: bold;
    &.style-mt-0 {
      margin-top: 0;
    }
  }
  .config-model-main-tips {
    font-size: 12px;
    color: #999;
    padding-top: 5px;
  }
</style>
